import { type ReownEnvironmentConfig } from '../models';

export const BASE_REOWN_CONFIG: Omit<ReownEnvironmentConfig, 'projectId'> = {
  analytics: false,
  enableReconnect: true,
  metadata: {
    description: 'Derefi',
    icons: [],
    name: 'Derefi',
    url: '',
  },
};
